<fin-cms-global-disruption-banner></fin-cms-global-disruption-banner>

<fcom-booking-header
  *ngIf="breadcrumbs$ | async"
  [loggedIn]="(loginStatus$ | async) === 'LOGGED_IN'"
  [breadcrumbs]="breadcrumbs$ | async"
  [phasesAria]="phasesAria$ | async"
  [currentStep]="currentStep$ | async"
  [homeUrl]="homeLink$ | async"
  [showLogin]="showHeaderLogin$ | async"
  [showBack]="showHeaderBack$ | async"
  [showBreadcrumbs]="false"
  [propagateBackClick]="showHeaderBack$ | async"
  [userName]="profileName$ | async"
  [profileType]="profileType$ | async"
  [showLanguageSelector]="true"
  [isMobile]="isMobile$ | async"
  [enableNewStepper]="enableNewStepper$ | async"
  (menuClick)="toggleMenu()"
  (breadcrumbClick)="navigateToStep($event)"
  (loginClick)="loginDialog.toggleLogin($event)"
  (backClick)="navigateBack($event)"
  (homeClick)="onHomeClick($event)"
>
</fcom-booking-header>

<fin-login-dialog [context]="LoginWidgetContext.BOOKING" #loginDialog></fin-login-dialog>

<fin-join-form
  *ngIf="joinService.joinDialogOpen$ | async"
  [fullScreen]="(isMobile$ | async) || (isTablet$ | async)"
  class="mr-xxlarge-t"
>
</fin-join-form>
<fin-sub-header
  *ngIf="
    (currentStep$ | async)?.id !== BOOKING_STEPS.ENTRY.id &&
    (currentStep$ | async)?.id !== BOOKING_STEPS.PURCHASE_SUCCESS.id
  "
  [staticHeight]="(currentStep$ | async)?.id !== BOOKING_STEPS.FLIGHT_SELECTION.id"
  [showInfoIcon]="true"
  [hasBasket]="hasBasket$ | async"
  [isBasketDisabled]="false"
  [hasActiveBasketState]="false"
  [hasBasketActionInMobileOnly]="true"
  (openBasket)="openBasket()"
  (changeStep)="edit($event)"
>
  <fin-global-booking-widget-summary-header
    *ngIf="bookingSummary$ | async as bookingSummary"
    [bookingSummary]="bookingSummary"
    [enableModifySearch$]="enableModifySearch$"
  ></fin-global-booking-widget-summary-header>
</fin-sub-header>
<main
  class="booking grid-max-width grid-col-12"
  [class.basket-hidden]="(showBasket$ | async) === false"
  [class.ps-clear-x]="isBookingFrontPage$ | async"
>
  <section
    class="grey-25-bg col-f"
    [ngClass]="{
      'sm-col-1-8 md-col-1-9': (showBasket$ | async) === true,
    }"
  >
    <section
      [ngClass]="{
        'booking-content': (currentStep$ | async).phase < BOOKING_STEPS.PURCHASE_REVIEW.phase,
      }"
    >
      <section class="inner-grid-content relative">
        <fcom-stepper-v2
          *ngIf="
            !isInsideNativeWebView &&
            (enableNewStepper$ | async) &&
            (isErrorRoute$ | async) === false &&
            (currentStep$ | async)?.id !== BOOKING_STEPS.PURCHASE_SUCCESS.id &&
            (currentStep$ | async)?.id !== BOOKING_STEPS.CHECKOUT.id
          "
          [ngClass]="{ 'grid-col-12 pr-clear': (currentStep$ | async).phase === BOOKING_STEPS.PURCHASE_REVIEW.phase }"
          [breadcrumbs]="stepper$ | async"
          [currentStep]="currentStep$ | async"
          [isTabletDown]="isTabletDown$ | async"
          (stepClick)="navigateToStep($event)"
        ></fcom-stepper-v2>
        <router-outlet></router-outlet>
      </section>
    </section>
  </section>

  <aside
    class="basket grow sm-col-9-12 md-col-10-12 grey-50-bg"
    *ngIf="(showBasket$ | async) === true"
    [class.open]="(basketOpen$ | async) === true"
  >
    <fin-booking-summary
      class="block grow"
      (close)="closeBasket()"
      (edit)="edit($event, true)"
      [currentStep$]="currentStep$"
      [unpaidServices$]="unpaidServices$"
      [flowContext]="TRACKING_CONTEXT"
    >
    </fin-booking-summary>
  </aside>
</main>
